import { exportScriptsCommand } from '../../commands/scripts/exportScripts';

export async function exportScriptsTui() {
  await exportScriptsCommand();
} 